import { FaBolt, FaShieldAlt, FaWallet, FaChartLine, FaUsers, FaMobileAlt } from "react-icons/fa";

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const APP_STORE_URL = "https://apps.apple.com/us/app/prepaid-meter/id6448630946";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.millzbdm.prepaidmeter";

export const features = [
  {
    icon: FaBolt,
    title: "Instant token vending",
    body: "Pay by bank transfer and get your electricity token in minutes, with no account required.",
  },
  {
    icon: FaShieldAlt,
    title: "Smart gate & visitors",
    body: "Issue access codes and manage visitors so your community stays secure.",
  },
  {
    icon: FaWallet,
    title: "One wallet for every bill",
    body: "Fund once and pay for energy, water and other community bills from the same place.",
  },
  {
    icon: FaChartLine,
    title: "Live energy monitoring",
    body: "Track consumption and balances in real time and avoid being caught without power.",
  },
  {
    icon: FaUsers,
    title: "Built for communities",
    body: "Central vending for estates and managers, with transparent billing for every household.",
  },
  {
    icon: FaMobileAlt,
    title: "Mobile first",
    body: "Everything on your phone, from recharging your meter to checking your transaction history.",
  },
];

export const steps = [
  { title: "Enter your meter ID", body: "We look up your meter and show the account details." },
  { title: "Tell us how much", body: "Add your name, email and the amount you want to buy." },
  { title: "Transfer & get your token", body: "Send the exact amount to the account shown and confirm to receive your token." },
];

export const stats = [
  { value: "24/7", label: "Vending availability" },
  { value: "< 2 min", label: "Typical token delivery" },
  { value: "100%", label: "Transparent billing" },
];

export const faqs = [
  {
    q: "Do I need an account to buy electricity?",
    a: "No. Enter your meter ID, confirm your details, transfer the amount and receive your token.",
  },
  {
    q: "How do I pay?",
    a: "After you continue, we show a bank account to transfer to. Transfer the exact amount, then tap “I have sent the money”.",
  },
  {
    q: "What if my payment isn’t confirmed yet?",
    a: "Give the bank a moment and try again. You can check once every 30 seconds.",
  },
  {
    q: "How long does my transfer window last?",
    a: "The payment details come with a countdown. If it runs out, start a new purchase.",
  },
  {
    q: "How do I get a meter for my community?",
    a: "Use the “Get a meter” button and our team will reach out.",
  },
];
